import { TagLeftIcon as ChakraTagLeftIcon } from '@chakra-ui/react'

import { TagLeftIconProps } from './TagLeftIcon.types'

export default function TagLeftIcon(props: TagLeftIconProps) {
  return <ChakraTagLeftIcon {...props} />
}
